import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import VCalendar from 'v-calendar'
import { Plugin } from 'vue'
import { createApp, markRaw } from 'vue'
import Vue3Sanitize from 'vue-3-sanitize'
import VuePdfEmbed from 'vue-pdf-embed'

import { SANITIZE_OPTIONS } from '@shared/constants/sanitize'
import ClickOutsideDirective from '@shared/directives/click-outside'
import pinia from '@shared/plugins/pinia'
import { extendQuillEditor } from '@shared/plugins/quill'
import { initTheme } from '@shared/plugins/theme'
import { initUiKit } from '@shared/utils/initializers/ui-kit'

import initIcons from '@pc/helpers/icon-initializer'

import App from './App.vue'
import { plugins } from './element-plus'
import i18n from './i18n'
import router from './router'

import '@cds/core/icon/register.js'
import '@fontsource/metropolis'
import '@shared/scss/styles.scss'

import '@vueup/vue-quill/dist/vue-quill.bubble.css'
import 'element-plus/theme-chalk/src/index.scss'
import 'v-calendar/dist/style.css'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

pinia.use(({ store }) => {
  store.router = markRaw(router)
})

const appPlugins = [...plugins, router, i18n, pinia, VCalendar, VuePdfEmbed]

const app = createApp(App)

initUiKit(app)

appPlugins.forEach((plugin) => {
  app.use(plugin as Plugin)
})

app.use(Vue3Sanitize, SANITIZE_OPTIONS)

initIcons()
initTheme()
extendQuillEditor()

app.directive('click-outside', ClickOutsideDirective)

app.mount('#patient-chat-app')
